import { SupportType } from '@stories/Widgets/YourSolution/YS/Context/types';
// Utilities for the transfer logic between the two //
export const checkCanTransfer = (form) => {
    return form.supportType === SupportType.Box;
};
